import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mobile",
  "use": "mobile-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"mobile\">\r\n    <path d=\"M19.14 3H9.86C8.88 3 8 3.8 8 4.9v20.2c0 1 .78 1.9 1.86 1.9h9.28c.98 0 1.86-.8 1.86-1.9V4.9c0-1.1-.78-1.9-1.86-1.9zm-5.96 1.3h2.64c.39 0 .68.3.68.6 0 .4-.29.7-.68.7h-2.64c-.29 0-.59-.3-.59-.7 0-.3.3-.6.59-.6zM14.55 26a.89.89 0 0 1-.88-.9c0-.5.39-.9.88-.9s.88.4.88.9-.39.9-.88.9zm5.47-2.8H8.98V6.8h11.04z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol